import { CartRemotePopupView } from 'desktop/es6/cart/view/popups/cart-remote-popup-view'
import { setCookie } from 'helpers/cookie-helper'
import { fractionNumber } from 'helpers/number-helpers'
import { getTemplate } from 'helpers/template-helper'
import { Defaults } from 'es-decorators'
import Backbone from 'init/backbone'
import { fader } from 'init/fader'

/**
 * Представление попапа заказа товаров с удаленного склада меньше минимума со страницы товара
 */

@Defaults({
  el: '.js-remote-items-popup',

  // необходимый маркер для отправки событий в ОКО
  popupType: 'add_popup',
})
export class RemoteItemsPopupView extends CartRemotePopupView {
  /** @inheritDoc */
  run () {
    this.template = getTemplate('#remote-items-template')
    this.initPopup()
    this.listenTo(Backbone, 'show-remote-popup', this.render)
    this.listenTo(this.settlement, 'sync', this.updateSum)
  }
  /**
   * @inheritDoc
   */
  render (model, qty) {
    qty = qty || 1

    let templateData = {
      item: model,
      qty: qty,
      currencySign: this.cart.currencySign,
      fractionNumber: fractionNumber,
    }
    this.$('.js-remote-content-container').html(this.template(templateData))
    this.open()
  }

  /**
   * Открываем попап
   */
  open () {
    // костыль для лебедевского попапа
    setTimeout(this.popup.open.bind(this.popup), 1)
    fader.show()
    this.saveCookie()
    this.okoPushOpen()
  }

  /**
   * Обновляем минимальную сумму для заказа.
   */
  updateSum () {
    this.$('.js-cart-status-sum').html(
      fractionNumber(this.settlement.get('min_order_sum'))[0]
    )
  }

  /**
   * Установка куки isRemotePopupShown на 10 лет
   */
  saveCookie () {
    setCookie(
      'isRemotePopupShown',
      1,
      {
        expires: 10 * 360 * 24 * 3600,
        path: '/',
      }
    )
  }
}
